 
export class Activation {
  requestId: number ;
  date: string ;
  validFor: string;
  logUser: string;
}
